export default "Coup de pouce CEE 2026 — La prime énergie majorée | Solution Éco France";
